"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.delete.confirm.title': 'Eliminar Paso',
    'step.delete.confirm.message': '¿Está seguro de que desea eliminar este paso?',
};
